// extracted by mini-css-extract-plugin
module.exports = {"Image":"Image_Image__1Lk3D","FullSizeImage":"Image_FullSizeImage__1NC_j"};